export default __webpack_public_path__ + "static/media/stop.7621693d.svg";